module.exports = __webpack_public_path__ + "static/010-261927e5762f75cb137fd8eca3b7bb82.jpg";